import { pageWidth } from '../functions/windowSizeFunctions';

export default class WCArchiveDescriptionLines {
    constructor() {
        this.archiveGrid = document.querySelector('.jsWcArchiveGrid');
        this.cartGrid = document.querySelector('.jsWcCartGrid');

        this.events();
    }

    events() {
        if (this.archiveGrid) {
            this.defineDescriptionLinesCount(this.archiveGrid);

            this.archiveGrid.addEventListener('addedNewProductsToGrid', () =>
                this.defineDescriptionLinesCount(this.archiveGrid),
            );
        }

        if (this.cartGrid) {
            this.cartGrid.addEventListener('crossSellSliderActive', () =>
                this.defineDescriptionLinesCount(this.cartGrid),
            );
        }
    }

    defineDescriptionLinesCount(currentGrid) {
        this.wcArchiveProduct = [
            ...currentGrid.querySelectorAll(
                ".jsWcArchiveProduct[data-height-adjusted='false']",
            ),
        ];

        if (!this.wcArchiveProduct.length) return;

        this.wcArchiveProduct.forEach((product) =>
            this.adjustInfoHeight(product),
        );
    }

    adjustInfoHeight(product) {
        const currentPageWidth = pageWidth();
        const margin = currentPageWidth < 768 ? 5 : 8;

        const productInfo = product.querySelector('.jsWcArchiveProductInfo');
        const productTitle = product.querySelector('.jsWcArchiveProductTitle');
        const productDescription = product.querySelector(
            '.jsWcArchiveProductDescription',
        );

        const productInfoHeight = productInfo.getBoundingClientRect().height;
        const productTitleHeight = productTitle.getBoundingClientRect().height;

        const productDescriptionSingleLineHeight =
            currentPageWidth < 768 ? 1.3 * 10 * 1.5 : 1.2 * 10 * 1.5;

        const productDescriptionLinesToDisplay = Math.floor(
            (productInfoHeight - productTitleHeight - margin) /
                productDescriptionSingleLineHeight,
        );

        product.setAttribute('data-height-adjusted', true);

        productDescription.style.setProperty(
            '--text-lines',
            productDescriptionLinesToDisplay,
        );
    }
}
